const GetLandingPageReducer = (state = { type: 'LOADING_LANDING_PAGE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_LANDING_PAGE_ACTION':
            return action
        case 'RESET_LANDING_PAGE_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetUserInfoV2LandingPageReducer = (state = { type: 'LOADING_USER_INFO_V2_LANDING_PAGE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_USER_INFO_V2_LANDING_PAGE_ACTION':
            return action
        case 'RESET_USER_INFO_V2_LANDING_PAGE_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetUserAccessReducer = (state = { type: 'LOADING_USER_ACCESS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_USER_ACCESS_ACTION':
            return action
        case 'RESET_USER_ACCESS_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetUserInfoReducer = (state = { type: 'LOADING_USER_INFO_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_USER_INFO_ACTION':
            return { ...state, type: 'LOADING_USER_INFO_ACTION', loading: true };
        case 'SUCCESS_USER_INFO_ACTION':
            return { ...action, loading: false };
        case 'ERROR_USER_INFO_ACTION':
            return { ...state, type: 'ERROR_USER_INFO_ACTION', loading: false, error: action.error };
        case 'RESET_USER_INFO_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetTileKpiOverviewReducer = (state = { type: 'LOADING_TILE_KPI_OVERVIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_TILE_KPI_OVERVIEW_ACTION':
            return action
        default:
            return state
    }
}
const GetBlankCategoriesReducer = (state = { type: 'LOADING_BLANK_CATEGORY_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_BLANK_CATEGORY_ACTION':
            return action
        default:
            return state
    }
}
const GetMaxDateReducer = (state = { type: 'LOADING_MAX_DATE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_MAX_DATE_ACTION':
            return action
        default:
            return state
    }
}

const GetSpendCardDataReducer = (state = { type: 'LOADING_SPEND_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SPEND_CARD_ACTION':
            return action
        default:
            return state
    }
}
const GetSupplierPerfCardDataReducer = (state = { type: 'LOADING_COMAN_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_COMAN_CARD_ACTION':
            return action
        default:
            return state
    }
}
const GetContractCardDataReducer = (state = { type: 'LOADING_CONTRACT_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_CONTRACT_CARD_ACTION':
            return action
        default:
            return state
    }
}
const GetSustainabilityCardDataReducer = (state = { type: 'LOADING_SUSTAINABILITY_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SUSTAINABILITY_CARD_ACTION':
            return action
        default:
            return state
    }
}

const GetArchletCardDataReducer = (state = { type: 'LOADING_ARCHLET_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_ARCHLET_CARD_ACTION':
            return action
        default:
            return state
    }
}
const GetMarketIntelInHouseCardDataReducer = (state = { type: 'LOADING_MI_INHOUSE_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_MI_INHOUSE_CARD_ACTION':
            return action
        default:
            return state
    }
}
const GetR2PInsightsCardDataReducer = (state = { type: 'LOADING_R2P_INSIGHTS_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_R2P_INSIGHTS_CARD_ACTION':
            return action
        default:
            return state
    }
}

const GetProcurementPageReducer = (state = { type: 'LOADING_PROC_PAGE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_PROC_PAGE_ACTION':
            return action.searchIndex?.length || !state.searchIndex
                ? action
                : { ...action, searchIndex: state.searchIndex }
        case 'SUCCESS_PROC_SEARCH_INDEX_ACTION':
            return {
                ...state,
                searchIndex: action.searchIndex
            };
        case 'RESET_PROC_PAGE_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetArgoToolsPageReducer = (state = { type: 'LOADING_AGRO_TOOLS_PAGE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_AGRO_TOOLS_PAGE_ACTION':
            return action
        case 'RESET_AGRO_TOOLS_PAGE_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


const GetTaxonomyReducer = (state = { type: 'LOADING_TAXONOMY_DATA_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_TAXONOMY_DATA_ACTION':
            return { ...state, type: 'LOADING_TAXONOMY_DATA_ACTION', loading: true };
        case 'SUCCESS_TAXONOMY_DATA_ACTION':
            return { ...action, loading: false };
        case 'ERROR_TAXONOMY_DATA_ACTION':
            return { ...state, type: 'ERROR_TAXONOMY_DATA_ACTION', loading: false, error: action.error };
        case 'RESET_TAXONOMY_DATA_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

export {
    GetLandingPageReducer,
    GetUserInfoV2LandingPageReducer,
    GetUserAccessReducer,
    GetSpendCardDataReducer,
    GetSupplierPerfCardDataReducer,
    GetContractCardDataReducer,
    GetMarketIntelInHouseCardDataReducer,
    GetSustainabilityCardDataReducer,
    GetBlankCategoriesReducer,
    GetMaxDateReducer,
    GetArchletCardDataReducer,
    GetTileKpiOverviewReducer,
    GetR2PInsightsCardDataReducer,
    GetProcurementPageReducer,
    GetArgoToolsPageReducer,
    GetUserInfoReducer,
    GetTaxonomyReducer
}